import { css } from 'linaria';
import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';

export type AdvantageStructure = {
  src: string;
  title: string;
  titleStyle?: string;
  description: string;
};

export const ADVANTAGES_LIST: AdvantageStructure[] = [
  {
    description: 'Даём гарантию от\u00A0Лемана\u00A0ПРО на\u00A0товары и\u00A0монтажные работы.',
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/advantages/1.svg/1.svg`,
    title: 'Гарантия\u00A0 Лемана ПРО',
    titleStyle: css`
      && {
        @media (--only-largeDesktop) {
          width: 150px;
        }
      }
    `,
  },
  {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/advantages/2.svg/2.svg`,
    title: 'Профессиональный проект',
    description:
      'Проект позволит рассчитать бюджет, снизить расходы, закупиться сразу всем, ускорить работы и\u00A0обеспечить безопасность системы.',
  },
  {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/advantages/3.svg/3.svg`,
    title: 'Квалифицированные бригады',
    description:
      'Прошли обучение от\u00A0производителя оборудования. Выполнят установку в\u00A0соответствии с\u00A0проектом и\u00A0нормами.',
  },
  {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/advantages/4.svg/4.svg`,
    title: 'Индивидуальный подход',
    description:
      'Предлагаем разные ценовые решения с\u00A0учётом ваших пожеланий и\u00A0особенностей объекта.',
  },
];
